import { StyleFunctionProps } from '@telescope/cassini-ui';
import { defineStyle } from '@chakra-ui/styled-system';
import { mode } from '@chakra-ui/theme-tools';

// Same as solid button, but the background and text colors are inverted
const variantSolidInverse = defineStyle((props) => {
  const { colorScheme: c, theme } = props;  
  const solidVariantProps = { ...theme.components.Button.variants.solid(props) };

  return {
    ...solidVariantProps,
    color: solidVariantProps.bg,
    bg: solidVariantProps.color,
    _hover: {
      bg: solidVariantProps.bg,
      color: solidVariantProps.color,
      _disabled: {
        bg: 'initial',
      },
    },
    _active: { bg: mode(`${c}.900`, `${c}.400`)(props) },
  };
});

const variantSolidBold = defineStyle((props) => {
  const { colorScheme: c, theme } = props;  
  const solidVariantProps = { ...theme.components.Button.variants.solid(props) };
  return {
    ...solidVariantProps,
    color: mode(`${c}.900`, `${c}.50`)(props),
    bg: `${c}.500`,
    _hover: {
      bg: mode(`${c}.900`, `${c}.50`)(props),
      color: `${c}.500`,
      _disabled: {
        bg: 'initial',
      },
    },
    _active: { 
      bg: mode(`${c}.900`, `${c}.100`)(props) 
    },
  };
});

export const buttonTheme = {
  baseStyle: { 
    whiteSpace: 'normal',
    _disabled: { pointerEvents: 'none' },
    _hover: { textDecoration: 'none' },
    fontWeight: 700
  },
  variants: {
    solidInverse: variantSolidInverse,
    solidBold: variantSolidBold,
    solid: (props: StyleFunctionProps) => {
      return ({
        bg: `${props.colorScheme}.500`,
        color: `${props.colorScheme}.50`,
        height: 'auto',
        minH: 10,
        px: 8,
        _hover: {
          bg: `${props.colorScheme}.600`
        },
        _active: {
          bg: `${props.colorScheme}.800`
        }
      })
    },
    link: (props: StyleFunctionProps) => ({
      color: `${props.colorScheme}.500`,
      _hover: { 
        color: mode(`${props.colorScheme}.600`, `${props.colorScheme}.300`)(props)
      },
    })
  },
};
